export const pendingBookings = {
  configTitle: "Configurer les réservations directes",
  configText:
    "Activez les réservations directes pour gérer ici même les paiements en attente et les demandes de réservation de vos voyageurs.",
  reminderLabel: "Rappel :",
  reminderReasonIntent: "paiement en attente de",
  reminderReasonUnassigned: "attribuer une chambre à",
  reminderReasonRequest: "demande à examiner de",
  combined: "Combiné · {count} chambres",
  expired: "Expiré",
  toastSuccessTitle: "Succès",
  toastErrorTitle: "Erreur",
  toastWarningTitle: "Avertissement",
};
